/** When your routing table is too long, you can split it into small modules**/

export default [
  
  {
    path: "/shafahi",
    name: "Shafahi",
    component: () => import("@/views/shafahi/Index"),
  },
];
